import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { RadioButton } from "primereact/radiobutton";
import { InputText } from "primereact/inputtext";
import { Message } from "primereact/message";

export function AssignEvseDialog({
	visible,
	url,
	onHide,
	onAssign,
}: {
	visible: boolean;
	url: string | null;
	onHide: () => void;
	onAssign: (evseId: string, isLocation: boolean) => Promise<void> | void;
}) {
	const [evseId, setEvseId] = useState<string>("");
	const [isLocation, setIsLocation] = useState<boolean>(false);

	useEffect(() => {
		if (!visible) {
			setEvseId("");
			setIsLocation(false);
		}
	}, [visible]);

	const footer = (
		<div>
			<Button label="Cancel" icon="pi pi-times" onClick={onHide} className="p-button-text" />
			<Button
				label={`Assign ${isLocation ? "Location" : "EVSE"}`}
				icon="pi pi-link"
				onClick={() => onAssign(evseId, isLocation)}
				autoFocus
			/>
		</div>
	);

	return (
		<Dialog
			header="Assign EVSE / Location to QR Code"
			visible={visible}
			style={{ width: "30rem" }}
			onHide={onHide}
			footer={footer}
		>
			<div className="flex flex-wrap gap-3 mb-4">
				<div className="flex align-items-center">
					<RadioButton inputId="evse" name="type" value={false} checked={!isLocation} onChange={(e) => setIsLocation(false)} />
					<label htmlFor="evse" className="ml-2">EVSE</label>
				</div>
				<div className="flex align-items-center">
					<RadioButton inputId="location" name="type" value={true} checked={isLocation} onChange={(e) => setIsLocation(true)} />
					<label htmlFor="location" className="ml-2">Location</label>
				</div>
			</div>

			<label htmlFor="evseId" className="block mb-2 text-lg ">
				{isLocation ? "Location ID" : "EVSE ID"}
			</label>
			<InputText id="evseId" className="block w-full" value={evseId} onChange={(e) => setEvseId(e.target.value)} />

			<Message
				severity="warn"
				className="mt-3 w-full"
				text={`Double-check the ${isLocation ? "Location" : "EVSE"} ID \u2014 it is not verified, and a wrong ID sends everyone scanning this code to a page that does not work.`}
			/>
		</Dialog>
	);
}